import { render, staticRenderFns } from "./CheckboxStatBox.vue?vue&type=template&id=03494347&scoped=true&"
import script from "./CheckboxStatBox.vue?vue&type=script&lang=js&"
export * from "./CheckboxStatBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03494347",
  null
  
)

export default component.exports